module.exports = __webpack_public_path__ + "media/tr_tr_s1_Aylin.24b0ce09.mp3";